import Vue from 'vue'
import Router from 'vue-router'
// import Home from './App.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        meta: {
            // requiresAuth: true
        }
      },
    ]
})

router.beforeEach((to, from, next) => {
    // console.log(to.matched.some)
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (router.app.$keycloak.authenticated) {
            next()
        } else {
            const loginUrl = router.app.$keycloak.createLoginUrl()
            window.location.replace(loginUrl)
        }
    } else {
        next()
    }
})
  
export default router
  
  